import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Home,
  LayoutDashboard,
  FolderKanban,
  FlaskConical,
  BookOpen,
  CalendarDays,
  Award,
  LogOut,
  X,
  Compass,
} from "lucide-react";
import { logoutUserThunk } from "../../../auth/authThunk";
import "../stem.css";

const STEM_NAV_ITEMS = [
  {
    // section: "MAIN",
    items: [
      {
        label: "Main Portal",
        icon: Home,
        to: "/dashboard",
        exact: true,
      },
    ],
  },
  {
    // section: "STEM MENU",
    items: [
      {
        label: "Dashboard",
        icon: LayoutDashboard,
        to: "/student-stem/dashboard",
        exact: true,
      },
      {
        label: "Projects",
        icon: FolderKanban,
        to: "/student-stem/projects",
      },
      // {
      //   label: "Experiments & Labs",
      //   icon: FlaskConical,
      //   to: "/student-stem/experiments",
      // },
      // {
      //   label: "Learning Modules",
      //   icon: BookOpen,
      //   to: "/student-stem/modules",
      // },
      // {
      //   label: "Activities & Schedule",
      //   icon: CalendarDays,
      //   to: "/student-stem/activities",
      // },
      // {
      //   label: "Certificates",
      //   icon: Award,
      //   to: "/student-stem/certificates",
      // },
    ],
  },
];

function getInitials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2) || "S";
}

export default function StemSidebar({ isOpen, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userData = (() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "{}");
    } catch {
      return {};
    }
  })();

  const userName = userData?.admin_name || userData?.school_name || "Student";
  const schoolName = userData?.school_name || "";

  const handleLogout = async () => {
    if (dispatch && logoutUserThunk) {
      await dispatch(logoutUserThunk());
    }
    localStorage.removeItem("userData");
    localStorage.removeItem("userToken");
    navigate("/login");
  };

  const handleNavClick = () => {
    if (onClose) onClose();
  };

  return (
    <aside className={`stem-sidebar ${isOpen ? "stem-sidebar--open" : ""}`}>
      {/* Logo & Header */}
      <div className="stem-sidebar-logo">
        <div className="stem-logo-icon">
          <Compass size={20} color="var(--white)" />
        </div>
        <div className="stem-logo-text">
          <span className="stem-logo-title">DocMaster STEM</span>
          <span className="stem-logo-sub">EXPLORATION</span>
        </div>
        <button
          className="stem-sidebar-close"
          onClick={onClose}
          title="Close menu"
          type="button"
        >
          <X size={16} strokeWidth={2} />
        </button>
      </div>

      {/* Navigation Links */}
      <nav className="stem-sidebar-nav">
        {STEM_NAV_ITEMS.map((group) => (
          <div key={group.section}>
            <div className="stem-nav-section-label">{group.section}</div>
            {group.items.map((item) => {
              const Icon = item.icon;
              const isActive = item.exact
                ? location.pathname === item.to
                : location.pathname.startsWith(item.to);

              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={handleNavClick}
                  className={`stem-nav-item ${isActive ? "active" : ""}`}
                >
                  <span className="stem-nav-icon">
                    <Icon size={16} strokeWidth={2} />
                  </span>
                  <span className="stem-nav-label">{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>

      {/* Footer / User Profile & Logout */}
      <div className="stem-sidebar-footer">
        <div className="stem-sidebar-user">
          <div className="stem-user-avatar">{getInitials(userName)}</div>
          <div className="stem-user-info">
            <div className="stem-user-name" title={userName}>
              {userName}
            </div>
            <div className="stem-user-role">Student</div>
            {schoolName && (
              <div className="stem-user-school" title={schoolName}>
                {schoolName}
              </div>
            )}
          </div>
        </div>

        <button
          type="button"
          className="stem-nav-item stem-nav-item--logout"
          onClick={handleLogout}
        >
          <span className="stem-nav-icon">
            <LogOut size={16} strokeWidth={2} />
          </span>
          <span className="stem-nav-label">Logout</span>
        </button>
      </div>
    </aside>
  );
}
